import React, { useEffect, useState } from 'react';
import List from '../../components/Crud/List';
import { useAuth } from '../../contexts/auth';
import InvoicesFilter, {
  InvoiceFilterFields,
} from '../invoices/InvoicesFilter';
import api from '../../services/api';
import {
  getLastFilterByKey,
  upsertFilterToKey,
} from '../../services/filterService';
import InvoicesList from '../invoices/InvoicesList';
import { InvoiceViewModel } from '../../models/Invoice/InvoiceViewModel';

interface CustomersEstimatesProps {
  customerId: number;
}

export default function CustomersInvoices({
  customerId,
}: CustomersEstimatesProps) {
  const pageKey = 'customers-invoices';
  const {
    user: { organization },
    isAdmin,
  } = useAuth();

  const [isLoading, setIsLoading] = useState(true);
  const [invoices, setInvoices] = useState([] as InvoiceViewModel[]);
  const [filterFields, setFilterFields] = useState<InvoiceFilterFields>(
    null as unknown as InvoiceFilterFields
  );

  async function getInvoices(data: InvoiceFilterFields) {
    if (organization) {
      setIsLoading(true);
      const { customer, isPaid, isNotPaid, ...rest } = data;
      const response = await api.get(
        `organizations/${organization.id}/invoices/filter`,
        {
          params: {
            customer: customerId,
            isPaid: isPaid || undefined,
            isNotPaid: isNotPaid || undefined,
            ...rest,
          },
        }
      );
      setInvoices(response.data.data);
      setIsLoading(false);
    }
  }

  const onFilterSubmit = (data: InvoiceFilterFields) => {
    const filter = new InvoiceFilterFields(data);
    upsertFilterToKey(pageKey, filter);
    setFilterFields(filter);
    getInvoices(data);
  };

  useEffect(() => {
    const filters = getLastFilterByKey(pageKey, InvoiceFilterFields);
    onFilterSubmit(filters);
  }, [organization]);

  return (
    <div className='mt-2'>
      <List
        isLoading={isLoading}
        title=''
        withTitle={false}
        newItemUrl={`/invoices/new?customerId=${customerId}`}
        withNewAction={isAdmin}
        withNewActionTargetBlank
        filter={
          <InvoicesFilter
            pageKey={pageKey}
            filterFields={filterFields}
            onSubmit={onFilterSubmit}
            withCustomerFilter={false}
          />
        }
      >
        <InvoicesList invoices={invoices} />
      </List>
    </div>
  );
}
